import React from "react";
import { Tooltip } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import "./styles.scss";

/**
 * TooltipContent Component - Explanation with an intro, a short list and a note
 *
 * @param {string} intro - First sentence
 * @param {string[]} items - List below the intro
 * @param {string} note - Last sentence, e.g. what is left out
 */
export const TooltipContent = ({ intro, items = [], note }) => (
  <div className="home-tooltip-content">
    {intro && <p>{intro}</p>}
    {items.length > 0 && (
      <ul>
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    )}
    {note && <p>{note}</p>}
  </div>
);

/**
 * InfoTooltip Component - Info icon that explains something on hover, like on the Tag Monitor dashboard
 *
 * @param {React.ReactNode} text - Explanation shown in the tooltip
 */
const InfoTooltip = ({ text }) => (
  <Tooltip title={text} styles={{ root: { maxWidth: 360 } }}>
    <InfoCircleFilled className="info-icon home-info-tooltip" />
  </Tooltip>
);

export default InfoTooltip;
